// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// MIT License

import { PetalumaFont } from './petaluma_glyphs';
import { PetalumaMetrics } from './petaluma_metrics';

export const Petaluma = {
  data: PetalumaFont,
  metrics: PetalumaMetrics,
};
